<template>
    <div class="collate">
        <div class='collate-page'>
            <div class="collate-top"></div>
            <div class="collate-content width90p">
                <!-- 1. 顶部菜单栏 -->
                <collate-title-bar></collate-title-bar>

                <!-- 2. 排盘输入时间表单 -->
                <collate-form 
                    v-bind:parentNode="parentNode" 
                    v-bind:chooseGroupFunc="clickChooseGroup"
                    v-bind:chooseLabelFunc="clickChooseLabel">
                </collate-form>

                <!-- 3. 每日日历 -->
                <calendar-info-bar></calendar-info-bar>

                <!-- 4. 关注二维码 -->
                <div v-if="CONFIG.platform == 'wechat'" class="collate-note">
                    <img class="collate-note-img" v-bind:src="qrCode" alt="">
                    <p class="collate-note-p">长按识别二维码关注公众号：木火通明八字</p>
                </div>
            </div>
        </div>
        <!-- 底部新增按钮 -->
        <div v-if="CONFIG.platform == 'wechat'" class="collate-sub-btn-box">
            <!-- <div @click="clickReport" class="collate-sub-btn collate-sub-btn-left"><button></button><span v-if="showYearReportRedCircle" class="red-circle"></span></div> -->
            <div @click="clickDonate" class="collate-sub-btn collate-sub-btn-right"><button></button></div>
        </div>

        <!-- 子路由 -->
        <router-view></router-view>

        <!-- 5. 选择地址组件 -->
        <van-overlay v-show="showArea" @click="clickShowAreaOverlay" />
        <vant-area v-show="showArea"></vant-area>

        <!-- 6. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel></input-birthday-panel>
        </van-popup>

        <!-- 7. 年度报告弹框 -->
        <van-popup class="collate-year-report-pop" v-bind:value="showYearReportPop" v-bind:close-on-click-overlay="false">
            <div class="collate-pop-close" @click="clickYearReportClose"><span><i class="iconfont icon-guanbi"></i></span></div>
            <div class="collate-yrp-content">
                <p class="collate-yrp-title">您的八字数据<span class="wd-fire">2019年度报告</span>已准备就绪，马上前往APP客户端生成吧~</p>
                <p class="collate-yrp-note">如果您是三清宫八字的老用户而且从未导入过历史数据，建议先微信关注公众号『木火通明八字』回复『三清宫』授权导入历史数据记录。</p>
            </div>
            <div class="collate-yrp-button-box">
                <button class="button-green collate-yrp-button" @click="checkYearReport">马上查看年报</button>
            </div>
        </van-popup>

        <!-- 8. 友情捐赠弹框 -->
        <van-popup class="collate-donate-pop" v-bind:value="showDonatePop" v-bind:close-on-click-overlay="false">
            <div class="collate-pop-close" @click="clickDonateClose"><span><i class="iconfont icon-guanbi"></i></span></div>
            <div class="collate-yrp-content collate-dp-content">
                <p class="collate-yrp-title">『助力传统文化复兴，我来加油』</p>
                <p>正在火热进行中~</p>
            </div>
            <div class="collate-yrp-button-box">
                <button class="button-green collate-yrp-button" @click="clickDonate">马上参与</button>
            </div>
        </van-popup>

        <!-- 10. 重复八字过滤弹框 -->
        <van-popup v-bind:value="showSamePop" class="layout-same-select-pop-box" @click-overlay="clickSameSelectOverlay">
            <vant-same-select-pop
                v-bind:selectedList="recordSameEightWordList"
                v-bind:itemFunc="clickSameListItem"
                v-bind:saveFunc="clickSameSave">
            </vant-same-select-pop>
        </van-popup>
    </div>
</template>

<script>
import CollateTitleBar from '../layouts/collate/CollateTitleBar.vue'
import CollateForm from '../layouts/collate/CollateForm.vue'
import VantArea from '../layouts/vant/VantArea.vue'
import InputBirthdayPanel from '../components/InputBirthdayPanel.vue'
import CalendarInfoBar from '../components/CalendarInfoBar.vue'
import VantSameSelectPop from '../layouts/vant/VantSameSelectPop.vue'
import { PAIPAN } from '../modules/data/core/paipan'
import { MOMENT_TIME } from '../modules/momenttime'
import { UA, LS } from '../modules/utils'
import { DOM } from '../modules/dom'
import { CONFIG } from '../modules/config'
export default {
    name:  'Collate',
    components: { CollateTitleBar, CollateForm, VantArea, InputBirthdayPanel, CalendarInfoBar, VantSameSelectPop},
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        showSamePop() {
            return this.$store.state.record.showSamePop;
        },
        recordSameEightWordList() {
            return this.$store.state.record.recordSameEightWordList;
        },
        showArea() {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        }
    },
    data(){
        return {
            CONFIG: CONFIG,
            parentNode: {'name': 'Collate'},
            qrCode: require('../assets/images/qrcode.png'),
            showYearReportPop: false,
            showYearReportRedCircle: false,
            showDonatePop: false
        }
    },
    mounted: function() {
        var me = this;
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        // 加载完成后,静默全局的基础数据
        this.$store.dispatch('initBasicData');
        setTimeout(() => {
            me.initDom();
        }, 100);
        this.$store.state.group.checkedGroup = false;
        setTimeout(() => {
            // me.initDonatePop();
            me.$store.dispatch('reminder/checkCollateExtTime');
            me.$store.dispatch('reminder/checkReportAIStatus');
        }, 2000);
    },
    methods:{
        initDom() {
            var curReportLS = LS.checkCollateYearReportStatus();
            this.showYearReportRedCircle = !curReportLS;
            if(CONFIG.platform == 'web') {
                this.$el.style.minHeight = (innerHeight - 52) + 'px';
            }
        },
        initDonatePop() {
            var curDonateLS = LS.checkCollateDonatePopStatus();
            this.showDonatePop = !curDonateLS;
            LS.setCollateDonatePopStatus(true);
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
        },
        clickChooseGroup() {
            // 非一级页面要用push的方式
            this.$store.state.collate.chooseGroupFromPage = '/collate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/choosegroup');
        },
        clickChooseLabel() {
            this.$store.state.collate.chooseLabelFromPage = '/collate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/label');
        },
        clickDonateClose() {
            LS.setCollateDonatePopStatus(true);
            this.showDonatePop = false;
        },
        clickDonate() {
            LS.setCollateDonatePopStatus(true);
            DOM.showParentPageByClassName('donate-page');
            this.$router.replace('/donate');
        },
        clickYearReportClose() {
            this.showYearReportPop = false;
        },
        clickReport() {
            this.showYearReportPop = true;
            this.showYearReportRedCircle = false;
            LS.setCollateYearReportStatus(true);
        },
        checkYearReport() {
            if(UA.isIphone()) {
                // window.location = 'https://testflight.apple.com/join/bdPtq3I0';
                window.location = 'https://apps.apple.com/cn/app/%E5%A4%A9%E6%97%B6%E5%AD%90%E5%B9%B3%E7%94%9F%E8%BE%B0%E5%85%AB%E5%AD%97-%E5%91%BD%E7%90%86%E7%B2%BE%E5%93%81/id1471841010';
            }
            if(UA.isAndroid()) {
                window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.muhuo.bz';
            }
        },
        clickSameSelectOverlay() {
            this.$store.state.record.showSamePop = false;
        },
        clickSameListItem(data) {
            this.$store.state.record.showSamePop = false;
            var me = this,
                curType = this.$store.state.collate.curStartCollateType,
                personInfo = this.$store.state.record.recordOriginalData[data.id];
            switch(curType) {
                case 'collate':
                    // 打开存在的八字
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$router.replace('/detail/collate/'+ personInfo.id);
                    break;
                case 'report':
                    // 打开存在的测算
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$store.dispatch('report/initReportAIConfig', null);
                    this.$store.dispatch('report/getReportInfo', {
                        detailInfo: personInfo,
                        cb: function() {
                            // 更新状态
                            var params = {"aitips": 1};
                            me.$store.dispatch('reminder/udpateExtList', {
                                params: params
                            });
                            me.$router.replace('/report/record/'+personInfo.id);
                        }
                    });
                    break;
                case 'sizhu':
                    // 打开存在的八字
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$router.replace('/detail/collate_advancedcollate/'+ personInfo.id);
                    break;
                default:
                    break;
            }
        },
        clickSameSave() {
            var formData = this.$store.state.collate.formData,
                curType = this.$store.state.collate.curStartCollateType;
            console.log('clickSameSave', formData, curType);
            this.$store.state.record.showSamePop = false;
            switch(curType) {
                case 'collate':
                    // 新建八字
                    this.$store.dispatch('collate/submitCollate', formData);
                    break;
                case 'report':
                    // 新建测算
                    this.$store.dispatch('collate/submitReport', formData);
                    break;
                case 'sizhu':
                    // 新建四柱起盘八字
                    this.$store.dispatch('collate/submitSiZhuCollate', formData);
                    break;
                default:
                    break;
            }
        }
    }
}
</script>
